function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "8.09in",
    height: "1.91in",
    viewBox: "0 0 582.27 137.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M154.45,49.5a5.73,5.73,0,1,0-5.73-5.73A5.74,5.74,0,0,0,154.45,49.5Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,72.41a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,154.45,72.41Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,49.5a5.73,5.73,0,1,0-5.73-5.73A5.74,5.74,0,0,0,131.54,49.5Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.07,
    cy: 17.19,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,72.41a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,131.54,72.41Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,49.5a5.73,5.73,0,1,0-5.72-5.73A5.73,5.73,0,0,0,143,49.5Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.53,
    cy: 17.19,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,72.41a5.73,5.73,0,1,0-5.72-5.73A5.72,5.72,0,0,0,143,72.41Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,83.87a5.73,5.73,0,1,0-5.73-5.73A5.74,5.74,0,0,0,154.45,83.87Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,95.32a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,154.45,95.32Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,106.78a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,154.45,106.78Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.07,
    cy: 40.1,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,95.32a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,131.54,95.32Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.53,
    cy: 40.1,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,95.32a5.73,5.73,0,1,0-5.72-5.73A5.72,5.72,0,0,0,143,95.32Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.53,
    cy: 63.01,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,118.24a5.73,5.73,0,1,0-5.73-5.73A5.74,5.74,0,0,0,154.45,118.24Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,129.69a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,154.45,129.69Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,141.15a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,154.45,141.15Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,118.24a5.73,5.73,0,1,0-5.73-5.73A5.74,5.74,0,0,0,131.54,118.24Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87,129.93a5.73,5.73,0,1,0-5.73-5.73A5.72,5.72,0,0,0,129.87,129.93Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,138.52a5.73,5.73,0,1,0-5.73-5.72A5.73,5.73,0,0,0,122,138.52Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.84,
    cy: 79.45,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.12,
    cy: 95.2,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.74,
    cy: 65.4,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.93,78.85a5.73,5.73,0,1,0-5.73-5.72A5.73,5.73,0,0,0,96.93,78.85Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.78,83.63a5.73,5.73,0,1,0-5.72-5.73A5.73,5.73,0,0,0,115.78,83.63Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.46,112.51a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,117.46,112.51Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.56,99.14a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,120.56,99.14Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.36,157.38a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,98.36,157.38Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,158.33a5.73,5.73,0,1,0-5.73-5.72A5.72,5.72,0,0,0,49.19,158.33Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73,145A5.73,5.73,0,1,0,69,139.24,5.73,5.73,0,0,0,74.73,145Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.67,168.84a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,86.67,168.84Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.4,
    cy: 40.1,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.56,65.25a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,120.56,65.25Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.84,53a5.73,5.73,0,1,0-5.72-5.73A5.72,5.72,0,0,0,75.84,53Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.12,49.5a5.73,5.73,0,1,0-5.72-5.73A5.73,5.73,0,0,0,112.12,49.5Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,118.24a5.73,5.73,0,1,0-5.72-5.73A5.73,5.73,0,0,0,143,118.24Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.53,
    cy: 85.92,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2,141.15a5.73,5.73,0,1,0-5.72-5.73A5.72,5.72,0,0,0,141.2,141.15Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.48,151.65a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,148.48,151.65Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.41,163.82a5.73,5.73,0,1,0-5.73-5.72A5.73,5.73,0,0,0,146.41,163.82Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.97,
    cy: 131.75,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.51,159.93a5.73,5.73,0,1,0-5.73-5.73A5.74,5.74,0,0,0,114.51,159.93Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.59,
    cy: 131.75,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.69,
    cy: 109.43,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.51,
    cy: 131.75,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.34,
    cy: 108.84,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8,164.06a5.73,5.73,0,1,0-5.73-5.73A5.72,5.72,0,0,0,183.8,164.06Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.34,
    cy: 131.75,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,152.61a5.73,5.73,0,1,0-5.73-5.73A5.74,5.74,0,0,0,160.89,152.61Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,61a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,154.45,61Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,164.06a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,160.89,164.06Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,175.52a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,160.89,175.52Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.88,
    cy: 108.84,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.35,164.06a5.73,5.73,0,1,0-5.73-5.73A5.72,5.72,0,0,0,172.35,164.06Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.88,
    cy: 131.75,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.17,152.61a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,218.17,152.61Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.17,164.06a5.73,5.73,0,1,0-5.73-5.73A5.72,5.72,0,0,0,218.17,164.06Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.17,175.52a5.73,5.73,0,1,0-5.73-5.73A5.72,5.72,0,0,0,218.17,175.52Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.79,
    cy: 108.84,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,164.06a5.73,5.73,0,1,0-5.73-5.73A5.73,5.73,0,0,0,195.26,164.06Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.79,
    cy: 131.75,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.25,
    cy: 108.84,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.71,164.06a5.73,5.73,0,1,0-5.72-5.73A5.72,5.72,0,0,0,206.71,164.06Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.25,
    cy: 131.75,
    r: 5.73,
    style: {
      fill: "#00a7e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,124h20.26c7.76,0,11.23,3.42,11.23,9.14,0,4.44-2.35,6.63-5.31,7.7v.11c4.18,1,6.89,3.72,6.89,9s-3.63,10.51-11.54,10.51H372.28Zm20.16,15.06c4,0,5.92-2.2,5.92-5.1,0-3.32-1.79-5.26-6.23-5.26H377.69v10.36Zm-.1,16.68c6,0,7.6-3.06,7.6-6.17,0-2.86-1.63-5.82-7.14-5.82H377.69v12Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.48,128.69H472.7V124h33v4.7H491.89v31.74h-5.41Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.81,124h5.41v36.44h-5.41Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.1,144.63c5.3-1.32,7.28-6.33,7.28-10.15,0-4.64-2.65-10.49-9.95-10.49H266.88v36.44h5.41V145H284.1a2.7,2.7,0,0,1,2.79,1.61l7,13.84h6.39Zm-19.81-15.94h15.25c4.34,0,6.43,2.32,6.43,5.79,0,2.55-1.27,5.79-6.58,5.79h-15.1Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.39,123.19c14.56,0,20.14,9.74,20.14,19s-5.58,19-20.14,19-20.14-9.74-20.14-19S320.83,123.19,335.39,123.19Zm0,4.67c-8.27,0-14.76,4.76-14.76,14.35s6.49,14.35,14.76,14.35,14.76-4.76,14.76-14.35S343.66,127.86,335.39,127.86Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.2,123.19c14.55,0,20.13,9.74,20.13,19s-5.58,19-20.13,19-20.14-9.74-20.14-19S425.64,123.19,440.2,123.19Zm0,4.67c-8.27,0-14.76,4.76-14.76,14.35s6.49,14.35,14.76,14.35S455,151.8,455,142.21,448.46,127.86,440.2,127.86Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.9,148.4c.11,6.49,6.19,8.16,11.67,8.16,5.73,0,9.79-2.18,9.79-6.13,0-3.3-2.59-4.67-6.75-5.38l-8.21-1.37c-4.31-.71-10.76-2.43-10.76-9.48,0-6.6,5.23-11,14.51-11,7.25,0,14.91,2.64,15.42,11.36h-5.38c-.45-2.84-2.08-6.69-10.75-6.69-4,0-8.42,1.67-8.42,5.93,0,2.23,1.47,4,5.93,4.77l8.88,1.52c2.84.51,10.91,1.88,10.91,9.28,0,9.23-8.27,11.87-15.58,11.87-8.16,0-16.63-2.84-16.63-12.83Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.14,148.49c-2,5.6-6.4,8.07-12.09,8.07-10,0-13.7-7.05-13.7-13.89,0-9.89,5.43-14.81,14-14.81,6.62,0,10.47,3.22,11.89,7.36h5.6c-1.87-9.31-11.09-12-17.89-12-12.38,0-19,8.37-19,18.92,0,14.1,9.89,19.12,19,19.12,9.46,0,16-5.65,17.74-12.74Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.88,53.58h5.38V85.12h22v4.67H266.88Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.45,52.66c14.56,0,20.14,9.74,20.14,19s-5.58,19-20.14,19-20.14-9.74-20.14-19S317.9,52.66,332.45,52.66Zm0,4.67c-8.26,0-14.76,4.77-14.76,14.36S324.19,86,332.45,86s14.76-4.77,14.76-14.35S340.72,57.33,332.45,57.33Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.68,53.58h5.38V76.75c0,6.55,4.36,9.29,11,9.29s11-2.74,11-9.29V53.58h5.38V76.1c0,9.68-5.38,14.6-16.38,14.6s-16.39-4.92-16.39-14.6Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.93,77.87C482,84.36,488.12,86,493.6,86c5.73,0,9.78-2.18,9.78-6.14,0-3.3-2.58-4.67-6.74-5.38l-8.22-1.37c-4.31-.71-10.75-2.43-10.75-9.48,0-6.59,5.23-11,14.51-11,7.25,0,14.91,2.64,15.41,11.36h-5.37c-.46-2.83-2.08-6.69-10.76-6.69-3.95,0-8.42,1.67-8.42,5.94,0,2.23,1.48,4,5.94,4.76l8.88,1.52c2.84.51,10.9,1.88,10.9,9.28,0,9.24-8.27,11.87-15.57,11.87-8.17,0-16.64-2.84-16.64-12.83Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.08,78C400.13,83.56,395.68,86,390,86c-10,0-13.7-7.05-13.7-13.9,0-9.89,5.43-14.81,14-14.81,6.62,0,10.47,3.22,11.9,7.36h5.59c-1.87-9.3-11.08-12-17.89-12-12.38,0-19,8.37-19,18.92,0,14.1,9.89,19.12,19,19.12,9.46,0,16-5.64,17.74-12.74Z",
    transform: "translate(-43.46 -38.04)",
    style: {
      fill: "#58595b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocusLogo);
export default __webpack_public_path__ + "static/media/locus-logo.3fc4e0c6b92b6a55c0d0fc23796f24c8.svg";
export { ForwardRef as ReactComponent };